const { common: { request: { get }} } = window.FEGORender;

export {
    get,
}
